
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ClubForm from "./ClubForm";
import { ClubFormValues } from "@/hooks/useClubs";

interface CreateClubDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: ClubFormValues) => Promise<boolean>;
}

const CreateClubDialog: React.FC<CreateClubDialogProps> = ({ 
  isOpen, 
  onOpenChange, 
  onSubmit 
}) => {
  const handleComplete = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>Create a New Club</DialogTitle>
          <DialogDescription>
            Start a community centered around your interests.
          </DialogDescription>
        </DialogHeader>

        <ClubForm onSubmit={onSubmit} onComplete={handleComplete} />
      </DialogContent>
    </Dialog>
  );
};

export default CreateClubDialog;
